import gql from 'graphql-tag';

export default gql`
mutation updateProductListAd (
    $id: ID!
    $name: String!
    $banner_url: String
    $type: ProductListAdType!
    $product_id: ID
    $image_url_desktop: String
    $image_url_mobile: String
    $is_active: Boolean!
    $active_from: String
    $active_to: String
    $urls: [ProductListAdUrlInput!]!
) {
    updateProductListAd (input: {
        id: $id,
        name: $name,
        banner_url: $banner_url,
        type: $type,
        product_id: $product_id,
        image_url_desktop: $image_url_desktop,
        image_url_mobile: $image_url_mobile,
        is_active: $is_active,
        active_from: $active_from,
        active_to: $active_to,
        urls: $urls,
    }) {
        id
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateProductListAd.ts